import { round } from "mathjs";
import { rupeeDisplay } from "./rupee";

// eslint-disable-next-line import/prefer-default-export
export const roundTwoDecimalPoint = (value: string | number): string => {
  const formatted = Number((Math.round(Math.abs(Number(value)) * 100) / 100).toFixed(2));
  return String(formatted);
};

export const roundOffWithRupeeDisplay = (num = 0): string =>
  rupeeDisplay(round(Number(num) || 0, 2), true);

export const removeCommasFromNumber = (num: string): string => {
  if (typeof num !== "string") return num;
  return num?.replace(/,/g, "");
};

/**
 * Rounds a number to the given number of decimal places.
 *
 * @param value - The number (or numeric string) to round
 * @param decimals - How many digits after the decimal (default = 2)
 * @returns number - Rounded number
 */
export function roundTo(value: number | string, decimals: number = 2): number {
  const num = Number(value);
  if (Number.isNaN(num)) throw new Error("Invalid number passed to roundTo");

  const factor = 10 ** decimals;
  return Math.round(num * factor) / factor;
}
